// @flow
import {
  TREE,
} from 'fc-users'

import traverse from 'fc-utils/traverse'

export default (traverse([TREE, 'authenticatedUser']): (state: Object) => ?number)
